export const queryStringToObject = (url: string) => {
  const params = new URL(url).searchParams;
  const result: Record<string, string | boolean | number> = {};

  params.forEach((value, key) => {
    result[key] = value;
  });

  return result;
};
